export const EARTH_RADIUS_KM = 6378.1

export const MAP_CENTER = { lat: 55.7504461, lng: 37.6174943 }

export const MAP_ZOOM = 12

export const GEOMETRY_CHANGE_DEBOUNCE_MS = 200

export const MAP_DEVICES_DISTANCE_KM = 100
